<template>
  <section class="question-reviewer">
    <nav class="question-picker" :aria-label="$t('levelTest.questionReview')">
      <button v-for="(item, index) in items" :key="item.id" ref="questionButtons" type="button"
        :class="['question-button', { active: index === activeIndex }]"
        :aria-current="index === activeIndex ? 'step' : undefined"
        :aria-label="`${$t('levelTest.questionNumber', { n: index + 1 })}，${item.statusLabel || ''}`"
        @click="select(index)" @keydown.left.prevent="move(-1, true)" @keydown.right.prevent="move(1, true)">
        {{ index + 1 }}<span v-if="item.mark" aria-hidden="true">{{ item.mark }}</span>
      </button>
    </nav>
    <div v-if="activeItem" :key="activeItem.id" ref="content" class="question-content" aria-live="polite">
      <slot :item="activeItem" :index="activeIndex" />
    </div>
    <div class="question-navigation">
      <button type="button" :disabled="activeIndex === 0" @click="move(-1)">{{ $t('levelTest.previousQuestion') }}</button>
      <span>{{ activeIndex + 1 }} / {{ items.length }}</span>
      <button type="button" :disabled="activeIndex === items.length - 1" @click="move(1)">{{ $t('levelTest.nextQuestion') }}</button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'QuestionReview',
  props: { items: { type: Array, required: true } },
  data() { return { activeIndex: 0 } },
  computed: { activeItem() { return this.items[this.activeIndex] } },
  methods: {
    select(index) {
      if (index < 0 || index >= this.items.length || index === this.activeIndex) return
      this.$refs.content?.querySelectorAll('audio').forEach(audio => audio.pause())
      this.activeIndex = index
    },
    move(direction, focus = false) {
      this.select(this.activeIndex + direction)
      if (focus) this.$nextTick(() => this.$refs.questionButtons[this.activeIndex]?.focus())
    }
  }
}
</script>

<style scoped>
.question-reviewer { text-align: left; }
.question-picker { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: var(--space-2); }
.question-button { display: flex; align-items: center; justify-content: center; gap: var(--space-1); min-height: 44px; border: 1px solid var(--border-default); border-radius: var(--radius-sm); background: var(--surface-panel); color: var(--ink-secondary); font: inherit; font-family: var(--font-family-data); font-size: var(--font-size-sm); cursor: pointer; }
.question-button.active { background: var(--ink-primary); color: var(--color-text-inverse); border-color: var(--ink-primary); }
.question-content { margin-top: var(--space-5); }
.question-navigation { display: flex; align-items: center; justify-content: space-between; gap: var(--space-3); margin-top: var(--space-5); padding-top: var(--space-3); border-top: 1px solid var(--border-subtle); }
.question-navigation button { min-height: 44px; padding: var(--space-2) var(--space-3); border: 1px solid var(--border-default); border-radius: var(--radius-sm); background: var(--surface-panel); color: var(--ink-primary); font: inherit; font-size: var(--font-size-sm); cursor: pointer; }
.question-navigation button:disabled { color: var(--ink-tertiary); cursor: not-allowed; }
.question-navigation > span { color: var(--ink-secondary); font-family: var(--font-family-data); font-size: var(--font-size-sm); }
button:focus-visible { outline: 2px solid var(--signal-active-strong); outline-offset: 2px; }
</style>
